import styled from 'styled-components';

export const Summary = styled.div`
  color: ${props => props.theme.gray};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 2px;
  margin: -30px 0 30px 0;
  text-transform: uppercase;
`;

export const Cars = styled.span`
  color: ${props => props.theme.red};
`;
